import { Route } from '@angular/router';
import { ShellStore } from '@kinet-open-network/client/shell/data-access';

export const appRoutes: Route[] = [
  {
    path: '',
    providers: [ShellStore],
    loadChildren: () => import('@kinet-open-network/client/shell/feature'),
  },
];
